import React, { Component } from 'react';
import LocaleStringsService from '../Services/LocaleStringsService.js';
import LocaleStringsList from '../Components/LocaleStrings/LocaleStringsList.js';
import { withApi } from '../Providers/WebServiceProvider.js';

class Validate extends Component
{
	constructor(props) {
		super(props);

		this.state = {
			strings: [],
			locale: null,
			isLoaded: false
		}

		this.stringsService = new LocaleStringsService(props.webServiceContext.getApi());
	}

	fetchStrings(locale) {
		var that = this;

		this.setState({ isLoaded: false });

		this.stringsService.fetchForLocale(locale)
			.then(function (results) {
				that.setState({ 
					strings: results.strings.filter(function (result) { return result.props.created_at !== null; }), 
					isLoaded: true,
					locale: results.locale
				});
			})
			.catch(function () {
				that.setState({ strings: [], isLoaded: true });
			});
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.match.params.locale !== nextProps.match.params.locale) {
			this.fetchStrings(nextProps.match.params.locale);
		}
	}

	componentDidMount() {
		this.fetchStrings(this.props.match.params.locale);
	}

  render () {
  	if (this.state.isLoaded) {
	 	  return (
	 	  	<div className="section">
		 	  	<div className="page-section">
				    <LocaleStringsList updater={this.stringsService.bulk} locale={this.state.locale} strings={this.state.strings} mode="validate" />
					</div>
				</div>
		  );
  	} else {
  		return ('Loading...');
  	}
  }
}

export default withApi(Validate);


// WEBPACK FOOTER //
// ./src/Pages/Validate.js